import type { NumberedListComponent } from "../../types";

/** Ordered numbered list renderer. */
export function NumberedListRenderer({ component }: { component: NumberedListComponent }) {
  const { items } = component.content;
  if (!items?.length) return null;
  return (
    <section className="mt-4 md:mt-6">
      {/* Retrait aligné sur les listes à tirets du bloc texte-photo. Sur mobile il est
          ramené à 24px : à 390px, une tabulation de 36px décalait visiblement la liste
          par rapport aux paragraphes tout en rognant la largeur utile. */}
      <ol className="list-decimal list-outside ml-6 md:ml-12 space-y-2 md:space-y-3 text-base xl:text-lg text-[#0F2849]">
        {items.map((text, i) => (
          <li key={i} className="pl-1.5">
            {text}
          </li>
        ))}
      </ol>
    </section>
  );
}
